import {
  Box,
  Group,
  Modal,
  ScrollArea,
  Skeleton,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";

import { useState } from "react";
import { SourceIcon } from "../../../../../utils/SourceIcon";
import { getEvidenceDisplayTitle, stripHtml } from "../../../../../utils";
import { OverflownText } from "../../../../OverflownText";
import { resolveEvidenceDisplayOrigin } from "../../../../../utils/evidence/evidenceDisplayOrigin";
import { getOriginalItemViewLabel } from "../../../../../utils/evidence/businessCategoryOriginalLabels";

const ProductBoardTicket = ({ item, isLoadingMl = false }: { item: any; isLoadingMl?: boolean }) => {
  const [opened, setOpened] = useState(false);
  const cxItemTitle = item?.cxItem?.title || item?.title;
  const cxItemText = item?.cxItem?.text || item?.text;
  const excerpt = item?.excerpt;
  const cxItem = item?.cxItem;
  const origin = resolveEvidenceDisplayOrigin(item) || "";
  const requestLinkLabel =
    getOriginalItemViewLabel(cxItem?.businessCategory) ||
    getOriginalItemViewLabel("request");
  const text = item?.text;
  // A blank title falls back to the first few words of the description — the text area
  // below still shows the full, untruncated text unchanged.
  const title = getEvidenceDisplayTitle(item?.title, text) || undefined;

  return (
    <>
      {opened && (
        <Modal
          opened={opened}
          centered
          onClose={() => setOpened(false)}
          size="600"
          title={
            <Group noWrap>
              {origin && (
                <Tooltip label={origin || "N/A"}>
                  <Stack h={20} w={20} mr={4} justify="center" align="center">
                    <SourceIcon sourceName={origin?.toLowerCase() || "N/A"} />
                  </Stack>
                </Tooltip>
              )}
              <OverflownText
                ml="3px"
                fz={17}
                maw={470}
                w={470}
                fw={600}
                lineClamp={1}
              >
                {cxItemTitle || "N/A"}
              </OverflownText>
            </Group>
          }
        >
          <Box h={600} px="md" w={500}>
            {cxItemText && (
              <Box py={8} px={12}>
                <Text
                  fz={14}
                  sx={{
                    whiteSpace: "pre-line",
                  }}
                >
                  {stripHtml(cxItemText)}
                </Text>
              </Box>
            )}
          </Box>
        </Modal>
      )}
      <Box mt={15} maw="100%">
        {title && (
          <Text fz={14} fw={600} lineClamp={1} mb={14}>
            {title}
          </Text>
        )}
        <ScrollArea
          mt={15} /* h={"calc(100vh - 700px)"} mah="calc(100vh - 700px)" */
        >
          {text && (
            <Box
              py={8}
              px={12}
              bg="#F8F9FA"
              sx={{ borderLeft: "2px solid rgba(92, 92, 235, 0.6)" }}
            >
              <Text
                fz={12}
                fw={600}
                color="#585C68"
                sx={{
                  whiteSpace: "pre-line",
                }}
              >
                {
                  isLoadingMl ? (
                    <div>
                      <Skeleton height={14} width="100%" mb={8} />
                      <Skeleton height={14} width="95%" mb={8} />
                      <Skeleton height={14} width="85%" />
                    </div>
                  ) : item?.ml?.functionalitySummary ? (
                    <div>
                      <b>Gap/Request: </b>
                      {stripHtml(item?.ml?.functionalitySummary)}
                      <br /><br />
                      <b>Underlying need: </b>
                      {stripHtml(item?.ml?.functionalityGap)}
                    </div>
                  ) : stripHtml(text)
                }
              </Text>
            </Box>
          )}
          {excerpt && excerpt !== "" && (
            <Box
              py={8}
              px={12}
              bg="#F8F9FA"
              sx={{ borderLeft: "2px solid rgba(92, 92, 235, 0.6)" }}
            >
              <Box fz={12}>
                <Text
                  mb="5px"
                  fw={600}
                  style={{ color: "black", fontSize: "12.5px" }}
                >
                  Excerpt:{" "}
                </Text>
                <Text
                  sx={{
                    whiteSpace: "pre-line",
                  }}
                >
                  {stripHtml(excerpt)}
                </Text>
              </Box>
            </Box>
          )}
        </ScrollArea>
        {
          <Box
            w="100%"
            py={8}
            px={12}
            bg="#F8F9FA"
            sx={{ borderLeft: "2px solid rgba(92, 92, 235, 0.6)" }}
          >
            <Text
              mt={10}
              fz={13}
              color="#5C5CEB"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => setOpened(true)}
            >
              {requestLinkLabel}
            </Text>
          </Box>
        }
      </Box>
    </>
  );
};

export default ProductBoardTicket;
